import { render, staticRenderFns } from "./AddToHomeIos.vue?vue&type=template&id=0d22a25e"
import script from "./AddToHomeIos.vue?vue&type=script&lang=js"
export * from "./AddToHomeIos.vue?vue&type=script&lang=js"
import style0 from "./AddToHomeIos.vue?vue&type=style&index=0&id=0d22a25e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports